/**
 * @copyright Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React from "react";

import styled from "styled-components";

import LabelDetailItem from "./LabelDetailItem";

import { APP_COLORS } from "../../../common/Constants";

const CompanyDetail = (props) => {
    const { company } = props;

    return (
        <MainContainer>
            <LabelDetailItem label={'Markets :'} description={company.indicators?.markets} />
            <LabelDetailItem label={'Projects :'} description={company.activity?.jobProjectTypes} />
            <LabelDetailItem label={'Services :'} description={company.services} />
            <LabelDetailItem label={'Project Value :'} description={'200k - 1M'} />
            <LabelDetailItem label={'Revenue :'} description={'20M - 50M'} />
            <LabelDetailItem label={'MSA :'} description={company.addressLocMsa} />
            <LabelDetailItem label={'Licensed :'} description={company.licenses?.licenses} />
            <LabelDetailItem label={'Associations :'} description={company.affiliations} />
        </MainContainer>
    )
}

export default CompanyDetail;

const MainContainer = styled.div`
    width: 100%;
  
    padding: 20px 0px;

    border-radius: 4px;
    border: 2px solid ${APP_COLORS['gray-300']}
`;
